import axios from 'axios';
import type { BasicReview } from '@shared/domain/review/index.js';
import type { Company } from '../../authentication/types/types.auth.js';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface RatingsInput {
  companyId: number;
  ratings: RatingValues;
  reviewId: number;
}

export interface RatingValues {
  clarity: number;
  responsiveness: number;
  transparency: number;
  understanding: number;
}

export const createCompanyFromReview = async (
  newCompany: any,
  idToken: string,
): Promise<Company> => {
  // Filter out empty stockTicker to send undefined instead of empty string
  const companyData = {
    companyName: newCompany.companyName,
    ...(newCompany.stockTicker?.trim() && { stockTicker: newCompany.stockTicker.trim() }),
  };

  const response = await axios.post(`${API_BASE_URL}/company`, companyData, {
    headers: {
      Authorization: idToken,
    },
  });

  return response.data;
};

export const createBasicReview = async (
  reviewInput: BasicReview,
  idToken: string,
): Promise<number> => {
  const response = await axios.post(`${API_BASE_URL}/review`, reviewInput, {
    headers: {
      Authorization: idToken,
    },
  });
  return response.data;
};

export const createBasicReviewRatings = async (
  ratingsInput: RatingsInput,
  idToken: string,
) => {
  return await axios.post(`${API_BASE_URL}/reviews/ratings`, ratingsInput, {
    headers: {
      Authorization: idToken,
    },
  });
};
